exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.HomeRed input {\r\n  border: none;\r\n  background: none;\r\n  margin-left: 10px;\r\n  width: 36vw;\r\n  font-size: 14px;\n}\n.HomeRed input::-webkit-input-placeholder {\r\n  color: #2565b6;\r\n  font-size: 14px;\n}\r\n", ""]);

// exports
